import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  getAddressesSuccessfully: false,
  addressesData: {
    _embedded: {}
  }
};

export default {
  name: "addresses",
  actions: {
    loadAddresses: payload => dispatch({ type: "LOAD_ADDRESSES", payload }),
    fetchAddresses: async function() {
      dispatch({ type: "FETCH_ADDRESSES" });
      const data = await req.get({
        api: "addresses"
      });
      this.loadAddresses(data);
    },
    removeAddress: async function(address) {
      dispatch({ type: "DELETE_ADDRESS" });
      // await req.delete({
      //   api: "addresses",
      //   params: address.id
      // });
      await fetch(`${HOST_URL}/shopping/v1/customers/addresses/${address.id}`, {
        credentials: "include",
        method: "DELETE",
        headers: {
          "content-type": "application/json"
        }
      });
    },
    newAddress: async function(address) {
      dispatch({ type: "NEW_ADDRESS" });
      // await req.post({
      //   api: "addresses",
      //   body: address
      // });
      await fetch(`${HOST_URL}/shopping/v1/customers/addresses`, {
        credentials: "include",
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(address)
      });
    },
    editAddress: async function(address, id) {
      dispatch({ type: "EDIT_ADDRESS" });
      // await req.patch({
      //   api: "addresses",
      //   body: address,
      //   params: id
      // });
      await fetch(`${HOST_URL}/shopping/v1/customers/addresses/${id}`, {
        credentials: "include",
        method: "PATCH",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(address)
      });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "LOAD_ADDRESSES":
        return {
          ...state,
          getAddressesSuccessfully: true,
          addressesData: action.payload
        };
      default:
        return state;
    }
  }
};
